import { ErrorPalette, SuccessPalette } from '@tcl-boron-colors/colors';
import { Fail, Success } from '@tcl-boron-icons/icons';
import { FinancialAssistanceStatuses } from 'requisition-service-shared';

type FAMessageConfig = {
  icon: React.ReactNode;
  title: string;
  message: string;
};

export const FA_MESSAGE_CONFIG: Partial<Record<string, FAMessageConfig>> = {
  [FinancialAssistanceStatuses.Denied]: {
    icon: <Fail color={ErrorPalette[700]} />,
    title: 'Financial Assistance Denied',
    message:
      'You have been denied financial assistance. If you have any questions, please contact our support team at help@tempus.com.',
  },
  [FinancialAssistanceStatuses.ApprovedNoMoreThan250]: {
    icon: <Success color={SuccessPalette[700]} />,
    title: 'Financial Assistance Approved',
    message: 'You have been approved for financial assistance. Your out of pocket cost will not exceed $250.',
  },
  [FinancialAssistanceStatuses.ApprovedNoMoreThan200]: {
    icon: <Success color={SuccessPalette[700]} />,
    title: 'Financial Assistance Approved',
    message: 'You have been approved for financial assistance. Your out of pocket cost will not exceed $200.',
  },
  [FinancialAssistanceStatuses.ApprovedNoMoreThan100]: {
    icon: <Success color={SuccessPalette[700]} />,
    title: 'Financial Assistance Approved',
    message: 'You have been approved for financial assistance. Your out of pocket cost will not exceed $100.',
  },
  [FinancialAssistanceStatuses.ApprovedForFullCoverage]: {
    icon: <Success color={SuccessPalette[700]} />,
    title: 'Financial Assistance Approved',
    message: 'You have been approved for full financial assistance coverage.',
  },
};
